import * as React from "react";

type upiIntentMethodFetchInProgressType = "notInitialted" | boolean;

export interface UpiIntentContextValue {
    availableMethods: string[];
    upiIntentMethodFetchInProgress: upiIntentMethodFetchInProgressType;
}

export const UpiIntentContext = React.createContext<UpiIntentContextValue>({
    availableMethods: [],
    upiIntentMethodFetchInProgress: "notInitialted",
});

if (__DEV__) {
    UpiIntentContext.displayName = "UpiIntentContext";
}
